import frontBuccalRef from '../../../../assets/images/spark/front_buccal.jpg';
import rightBuccalRef from '../../../../assets/images/spark/right_buccal.jpg';
import leftBuccalRef from '../../../../assets/images/spark/left_buccal.jpg';
import upperOcclusalRef from '../../../../assets/images/spark/upper_occlusal.jpg';
import lowerOcclusalRef from '../../../../assets/images/spark/lower_occlusal.jpg';
import profileRightRef from '../../../../assets/images/spark/right_profile.jpg';
import profileLeftRef from '../../../../assets/images/spark/left_profile.jpg';
import frontalRestRef from '../../../../assets/images/spark/frontal_rest.jpg';
import frontalSmileRef from '../../../../assets/images/spark/frontal_smile.jpg';
import type { CreationPhotoSlotId } from './photoSlots';

export const PHOTO_SLOT_REFERENCE_IMAGES: Readonly<Record<CreationPhotoSlotId, string>> = {
    front_buccal: frontBuccalRef,
    right_buccal: rightBuccalRef,
    left_buccal: leftBuccalRef,
    upper_occlusal: upperOcclusalRef,
    lower_occlusal: lowerOcclusalRef,
    profile_right: profileRightRef,
    profile_left: profileLeftRef,
    frontal_rest: frontalRestRef,
    frontal_smile: frontalSmileRef
};
